export function applyFormula(fields, data) {
  const result = { ...data };

  for (const { field, formula } of fields) {
    // Replace variable names with values from the data (default to 0)
    const safeFormula = formula.replace(/\b[a-zA-Z_]\w*\b/g, match =>
      match in result ? result[match] : 0
    );

    // Validate: only allow digits, spaces, basic math operators, decimal points, and parentheses
    if (!/^[\d\s+\-*/()%\.]*$/.test(safeFormula)) {
      result[field] = null;
      continue;
    }

    try {
      // Safely evaluate math expression
      const value = new Function(`return (${safeFormula})`)();
      result[field] = Number.isFinite(value) ? value : null;
    } catch {
      result[field] = null;
    }
  }

  return result;
}